<script>
  import { ArrowDown, ArrowUp } from "lucide-svelte";
  import { Render } from "svelte-headless-table";

  export let cell;
</script>

{#if cell.row.cellForId["marginPercent"].value < 0}
  <div
    class="flex flex-row border rounded-full border-red-500 text-red-500 text-xs w-[62px] p-1"
  >
    <ArrowDown class={"h-3 w-3 "} />
    <div class="px-1">
        <Render of={cell.row.cellForId["marginPercent"].render()} />
    </div>
  </div>
{:else if cell.row.cellForId["marginPercent"].value > 0}
  <div
    class="flex flex-row border rounded-full border-green-500 text-green-500 text-xs w-[62px] p-1"
  >
    <ArrowUp class={"h-3 w-3 "} />
    <div class="px-1">
        <Render of={cell.row.cellForId["marginPercent"].render()} />
    </div>
  </div>
{:else}
  <Render of={cell.row.cellForId["marginPercent"].render()} />
{/if}
